/* eslint-disable max-len */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'interfaces';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/session/create-session'] || initialState;

export const selectLoader = createSelector([selectDomain], (CreateSessionState) => CreateSessionState.loading);
export const selectModalLoader = createSelector([selectDomain], (CreateSessionState) => CreateSessionState.modalLoading);
export const selectActive = createSelector([selectDomain], (CreateSessionState) => CreateSessionState.isActive);

export const selectGroupsResult = createSelector([selectDomain], (CreateSessionState) => CreateSessionState.groupsResult);
export const selectSessionsResult = createSelector([selectDomain], (CreateSessionState) => CreateSessionState.sessionsResult);

export const selectSession = createSelector([selectDomain], (CreateSessionState) => CreateSessionState.session);
export const selectPendingSlots = createSelector([selectDomain], (CreateSessionState) => CreateSessionState.pendingSlots);

export const selectLocations = createSelector([selectDomain], (CreateSessionState) => CreateSessionState.session.locations);
